import React, { useState, useCallback } from 'react';
import { useFormState } from 'react-final-form';
import { ReferenceInput, SelectInput } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center'
    }
});

const spySubscription = { values: true };

const ApplicationReferenceInput = props => {
    const classes = useStyles();
    const [version, setVersion] = useState(0);

    return (
        <div className={classes.root}>
            <ReferenceInput key={version} {...props}>
                <SelectInput optionText="name" fullWidth {...props}/>
            </ReferenceInput>
        </div>
    );
};

export default ApplicationReferenceInput;